import styled, { css } from 'styled-components';
import { spacing } from '@pb/styles';
import { Paragraph } from '@pb/shared/ui/atoms/paragraph';
import { Heading } from '@pb/shared/ui/atoms/heading';

export const StyledAccordion = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-bottom: 2.4rem;
    padding: 1.2rem;
    background: ${({ theme }) => theme.color.grey1};
    box-shadow: 0 0.8rem 1.6rem 0 rgba(0, 0, 0, 0.08);
`;

export const StyledAccordionHeadingContainer = styled.button`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 100%;
    padding: 0.5rem;
    background: none;
    border: none;
    cursor: pointer;
`;

export const StyledAccordionHeading = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    cursor: pointer;
`;

export const StyledHeadingStepNumber = styled(Paragraph)`
    color: ${({ theme }) => theme.color.darkPurple};
    font-size: ${({ theme }) => theme.font.size.small};
`;

export const StyledHeadingStepName = styled(Heading)`
    color: ${({ theme }) => theme.color.purple};
    margin-top: ${spacing(1)};
`;

export const StyledBasicInfoStepNumber = styled(Paragraph)`
    color: ${({ theme }) => theme.color.grey6};
    font-size: ${({ theme }) => theme.font.size.small};
`;

export const StyledAllStepsContainer = styled.div`
    display: flex;
    gap: ${spacing(5)};
    align-items: center;
`;

export const StyledStepIconsContainer = styled.div`
    margin: 0;
`;

export const StyledStepDetailsContainer = styled.div<{ position: string }>`
    margin: 0;
    ${({ position }) =>
        position === 'Previous' &&
        css`
            cursor: pointer;
        `}
`;

export const StyledIconConnector = styled.div`
    border-left: ${spacing(1)} solid ${({ theme }) => theme.color.grey4};
    height: ${spacing(4)};
    margin-left: 1.4rem;
`;

export const StyledInvisibleIconConnector = styled.div`
    height: ${spacing(4)};
`;

/* PREVIOUS - SUCCESS STATES */
export const StyledSuccessIcon = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    height: ${spacing(8)};
    width: ${spacing(8)};
    background-color: ${({ theme }) => theme.color.green};
`;

export const StyledSuccessStepName = styled.p`
    font-family: ${({ theme }) => theme.font.family.primary};
    font-weight: ${({ theme }) => theme.font.weight.bold};
    color: ${({ theme }) => theme.color.green};
    margin: 0;
`;

/* PREVIOUS - ACTION NEEDED STATES */
export const StyledActionNeededIcon = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    height: ${spacing(8)};
    width: ${spacing(8)};
    font-family: ${({ theme }) => theme.font.family.primary};
    font-weight: ${({ theme }) => theme.font.weight.bold};
    font-size: 2.4rem;
    background-color: ${({ theme }) => theme.color.purple};
    color: ${({ theme }) => theme.color.white};
`;

export const StyledActionNeededStepName = styled.p`
    font-family: ${({ theme }) => theme.font.family.primary};
    font-weight: ${({ theme }) => theme.font.weight.bold};
    color: ${({ theme }) => theme.color.purple};
    margin: 0;
`;

/* CURRENT STEP STATES */
export const StyledCurrentStepIcon = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    height: ${spacing(8)};
    width: ${spacing(8)};
    font-family: ${({ theme }) => theme.font.family.primary};
    font-weight: ${({ theme }) => theme.font.weight.bold};
    background-color: ${({ theme }) => theme.color.indigo};
    color: ${({ theme }) => theme.color.white};
`;

export const StyledCurrentStepName = styled.p`
    font-family: ${({ theme }) => theme.font.family.primary};
    font-weight: ${({ theme }) => theme.font.weight.bold};
    color: ${({ theme }) => theme.color.indigo};
    margin: 0;
`;

/* FUTURE STEP STATES */
export const StyledFutureStepNumber = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    border: 0.1rem solid ${({ theme }) => theme.color.grey6};
    border-radius: 50%;
    height: ${spacing(8)};
    width: ${spacing(8)};
    font-family: ${({ theme }) => theme.font.family.primary};
    font-weight: ${({ theme }) => theme.font.weight.bold};
    color: ${({ theme }) => theme.color.grey6};
`;

export const StyledFutureStepName = styled(Paragraph)`
    color: ${({ theme }) => theme.color.grey6};
    font-size: ${({ theme }) => theme.font.size.base};
    font-weight: ${({ theme }) => theme.font.weight.regular};
    margin: 0;
`;
